const WORKSPACE_GROUPS_KEY_BASE = 'workspace_groups';
const GROUP_DATA_KEY_BASE = 'group_data';
const GROUP_MEMBERS_KEY_BASE = 'group_members';
export const WorkspaceGroupsKeyFactory = {
    all: () => [WORKSPACE_GROUPS_KEY_BASE],
    byWorkspace: (workspaceId) => [
        ...WorkspaceGroupsKeyFactory.all(),
        workspaceId,
    ],
    groupData: (workspaceId, groupId) => [
        ...WorkspaceGroupsKeyFactory.all(),
        GROUP_DATA_KEY_BASE,
        workspaceId,
        groupId,
    ],
    groupMembers: (workspaceId, groupId) => [
        ...WorkspaceGroupsKeyFactory.all(),
        GROUP_MEMBERS_KEY_BASE,
        workspaceId,
        groupId,
    ],
};
